import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=e70f331a&scoped=true&lang=pug&"
import script from "./Password.vue?vue&type=script&lang=ts&"
export * from "./Password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70f331a",
  null
  
)

export default component.exports